"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KHInputSet = void 0;
/**
 * A set of derived inputs that defines all of the inputs for a given scope.
 * They are combined to allow easily clearing unused inputs from the input
 * registrar. Derived inputs must only be included in one KHInputSet, or they
 * will return incorrect values (e.g. losing JustDown from being updated twice
 * in the same frame).
 */
class KHInputSet {
    constructor(identifier, inputs = []) {
        this.identifier = identifier;
        this.inputs = inputs;
    }
    addInput(input) {
        this.inputs.push(input);
    }
    registered() {
        return this.registrar != null;
    }
    update(now, delta) {
        for (let i = 0; i < this.inputs.length; i++) {
            this.inputs[i].updateDerivedInput(now, delta);
        }
    }
    registerWith(registrar) {
        var _a;
        if (this.registrar) {
            if (this.registrar === registrar)
                return;
            console.warn(`Input set ${this.identifier} already registered. Unregistering from previous set.`);
            this.registrar.unregisterInputSet(this);
        }
        this.registrar = registrar;
        (_a = this.registrar) === null || _a === void 0 ? void 0 : _a.registerInputSet(this);
    }
    unregister() {
        var _a;
        (_a = this.registrar) === null || _a === void 0 ? void 0 : _a.unregisterInputSet(this);
    }
}
exports.KHInputSet = KHInputSet;
